import MenuMaker from './MenuMaker'

export default MenuMaker
